<template>
  <div class="quantity">
    <button
      @click="decreaseQuantity()"
      class="quantity__decrease"
      aria-label="Decrease item quantity"
      :disabled="quantity <= min"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />
      </svg>
    </button>
    <p class="quantity__amount">
      {{ quantity }}
    </p>
    <button
      @click="increaseQuantity()"
      class="quantity__increase"
      aria-label="Increase item quantity"
      :disabled="max && quantity >= max"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 4.5v15m7.5-7.5h-15"
        />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number
    }
  },
  data() {
    return {
      quantity: this.value
    };
  },
  watch: {
    value(value) {
      this.quantity = value;
    }
  },
  methods: {
    decreaseQuantity() {
      if (this.quantity > this.min) {
        this.quantity--;
        this.$emit('change', this.quantity);
      }
    },
    increaseQuantity() {
      if (!this.max || this.quantity < this.max) {
        this.quantity++;
        this.$emit('change', this.quantity);
      }
    }
  }
};
</script>
